import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import Exercise from "../../models/exercise.model";
import { ExerciseService } from "../../services/exercise.service";

@Component({
  selector: "ngx-dialog-exercise-content",
  templateUrl: "dialog-exercise-content.component.html",
  styleUrls: ["dialog-exercise-content.component.scss"],
})
export class DialogExerciseComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() header: string;
  @Input() mode: string;
  @Input() exercise: Exercise = new Exercise();

  exerciseId: string = "";

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  menu = "info";
  imageURL = "";
  user: User;
  uid = "";

  constructor(
    public userService: UserService,
    protected ref: NbDialogRef<DialogExerciseComponent>,
    private fb: FormBuilder,
    private exerciseService: ExerciseService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
        } else {
          this.uid = "";
        }
      });

    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    const descriptionValidators = [
      Validators.minLength(3),
      Validators.maxLength(500),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      description: ["", descriptionValidators],
      sourceType: [Validators.required],
      privacy: [Validators.required],
      content: [],
      url: [],
    });

    if (this.exercise && this.exercise.id != "") {
      this.exerciseId = this.exercise.id;
    }

    if (this.exercise.tags && this.exercise.tags.length > 0) {
      var trees = new Set([]);
      this.exercise.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("Thử thách");
    }

    if (!this.exercise.status) {
      this.status = "0";
    } else {
      this.status = this.exercise.status.toString();
    }

    if (this.exercise.coverUrl && this.exercise.coverUrl != "") {
      this.imageURL = this.exercise.coverUrl;
    }
    if (!this.exercise.messageCompleted) {
      this.exercise.messageCompleted = "";
    }
    if (this.exercise.privacy == null || this.exercise.privacy == undefined) {
      this.exercise.privacy = false;
    }
    if (
      this.exercise.newComment == null ||
      this.exercise.newComment == undefined
    ) {
      this.exercise.newComment = true;
    }
    if (
      this.exercise.showComments == null ||
      this.exercise.showComments == undefined
    ) {
      this.exercise.showComments = true;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.exercise);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.exercise.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.exercise.coverUrl = "";
    this.imageURL =
      "https://kasoft-learning.s3.ap-southeast-1.amazonaws.com/assets/images/image-upload-bg.jpg";
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.exercise.tags = tags;
    this.exercise.status = parseInt(this.status);

    if (!this.user.admin && !this.user.moderator) {
      this.exercise.privacy = false;
      this.exercise.newComment = false;
      this.exercise.showComments = false;
    }

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    this.exerciseService
      .create(this.exercise)
      .then((data) => {
        this.exercise = data;
        this.exerciseId = data.id;

        this.loading = false;
        this.submitted = false;

        this.showToast("success", "Tạo thử thách", "thành công");
        this.mode = "edit";
        this.menu = "content";
        // this.ref.close(this.exercise);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Tạo thử thách", "thất bại");
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.exerciseService
      .update(this.exercise)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.showToast("success", "Cập nhật thử thách", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật thử thách", "thất bại");
      });
  }

  //callback from update quizzes
  private updateQuizzes(item: Exercise) {
    if (item) {
      this.loading = true;
      this.submitted = true;

      this.exerciseService
        .updateQuizzes(item.id, item.exQuizzes)
        .then((result) => {
          this.loading = false;
          this.submitted = false;

          this.edited = true;

          this.showToast("success", "Cập nhật danh sách câu hỏi", "thành công");
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
          this.showToast("warning", "Cập nhật danh sách câu hỏi", "thất bại");
        });
    }
  }

  //Images

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value.trim().toUpperCase());
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
